import { unescape as s } from "./help-center-knowledge-anatomies44.js";
let e = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: s
};
const a = (t = {}) => {
  e = {
    ...e,
    ...t
  };
}, r = () => e;
export {
  r as getDefaults,
  a as setDefaults
};
//# sourceMappingURL=help-center-knowledge-anatomies43.js.map
